import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
// import { getUser } from 'src/utils/Common';
import Koordinat from '../../components/GeoLocation';


const useStyles = makeStyles((theme) => ({
  root: {},
  review: {
    marginTop: theme.spacing(2)
  },
  submitButtonKoordinat: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function Lokasyon({ className, ...rest }) {
  const classes = useStyles();
  // const SessionUser = getUser();
  // const KoordinatTeknisyenKodu = SessionUser.TechnicianId;
  // const handleKoordinatAppOpen = (event) => {
  //   localStorage.removeItem('ArtemisApp');
  //   sessionStorage.removeItem('ArtemisApp');
  //   localStorage.setItem('ArtemisApp', 1);
  //   sessionStorage.setItem('ArtemisApp', 1);
  //   var AppLink = "artemis://lokasyon.com?control=1&technicianId=" + KoordinatTeknisyenKodu.toString();
  //   try {
  //     event.persist();
  //     window.open(AppLink, '_self');
  //     event.persist();
  //   } catch (error) {

  //   }
  // }


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Koordinat />
    </div>
  );
}

Lokasyon.propTypes = {
  className: PropTypes.string
};

export default Lokasyon;
